import {normalizeExpirationFromIccExpiryDate} from '@/services/sso/ssoExpiration';

export const authMapping = (responseData) => {
    const RESPONSE_DELAY_MS = 10 * 1000;
    const expirationDate = Date.now() + responseData.expires_in * 1000 - RESPONSE_DELAY_MS;

    return {
        accessToken: responseData.access_token,
        gigyaToken: responseData.profile?.et,
        refreshToken: responseData.refresh_token,
        expirationDate,
    };
};

export const loginTokenMapping = (responseData) => {
    return {
        url: responseData.CampaignUrlPersonal,
        expirationDate: normalizeExpirationFromIccExpiryDate(responseData.ExpiryDate),
    };
};

export const loginTokenListMapping = (responseData) => {
    const mapSingleResponse = (data) => {
        if (!data) return;

        return {
            id: data.Id || data.AutoLoginLinkName,
            url: data.Url,
            directUrl: data.DirectUrl,
            expirationDate: normalizeExpirationFromIccExpiryDate(data.ExpiryDate),
        };
    };

    const rawSessionInfo = responseData?.SessionInfo;
    const sessionInfo = rawSessionInfo
        ? {
              gigyaToken: rawSessionInfo.GigyaToken,
              gigyaId: rawSessionInfo.GigyaId,
              gigyaLoginToken: rawSessionInfo.GigyaLoginToken,
              hybrisToken: rawSessionInfo.HybrisToken,
              hybrisRefreshToken: rawSessionInfo.HybrisRefreshToken,
              domain: rawSessionInfo.Domain,
          }
        : null;

    return {
        autoLoginLinkNames: responseData?.AutoLoginLinkNames?.map(mapSingleResponse) || [],
        autoLoginLinkUrls: responseData?.AutoLoginLinkUrls?.map(mapSingleResponse) || [],
        sessionInfo,
    };
};

export const authUamMapping = (responseData, codentify) => {
    return {
        uamAuthToken: responseData.AuthToken,
        uamApiUrl: responseData.UamUrl,
        uamApiKey: responseData.UamApiKey,
        assetId: responseData.Assets?.[0]?.assetId,
        codentify,
    };
};
